// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"700":"ba63472d","840":"ba63472d","911":"ba63472d"}[chunkId] + ".css";
};